<template>
    <li class="tab-item splide__slide">
        <slot></slot>
    </li>
</template>

<script>
export default {
    name: "VTabItem",
    computed: {
        tab: function () {
            return this.$parent.tab
        }
    }
}
</script>
